module.exports = __webpack_public_path__ + "media/assets/images/flags/ir-706b78af664f936d6f073cf07f1b0908.svg";